import styled from 'styled-components';

const PageTitle = styled.h1`
margin: 0;
font-size: 30px;
font-family: Ubuntu, sans-serif;
color: var(--bicollab-primary-color-blue-900, #002c57);
`;

export default PageTitle;